module.exports = __webpack_public_path__ + "3dde8a0e5e2115b7f71e5449412ec28f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/personal-energy-gradient.png
// module id = 1871
// module chunks = 1